/**
 * 产品设计文档清单（源文件在仓库根目录，经 scripts/sync-design-docs.sh 同步到 public/design/）
 */
export const DESIGN_DOCS = [
  {
    id: 'product',
    title: 'CoolPeople 产品设计',
    description: '访问控制、登录、测评、创作者分账、管理后台',
    file: '/design/product-design.html',
    source: '产品设计.html'
  },
  {
    id: 'invite-referral',
    title: '邀请码与推荐券',
    description: '邀请码现状、推荐券、合伙人分润',
    file: '/design/invite-referral-design.html',
    source: '邀请码与推荐券产品设计.html'
  },
  {
    id: 'exam-json',
    title: '测评题目 JSON 设计',
    description: '测评数据结构、导入导出说明',
    file: '/design/exam-json-design.html',
    source: '测试设计.html'
  },
  {
    id: 'security',
    title: '系统安全审计报告',
    description: '待处理安全项与整改建议',
    file: '/design/security-report.html',
    source: '安全报告.html'
  }
]

export function findDesignDoc(id) {
  return DESIGN_DOCS.find((d) => d.id === id) || DESIGN_DOCS[0]
}
